var _defs, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack396({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 1.5,
    y: 1.5,
    width: 13,
    height: 13
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.78,11.16,5.55,5.57H6.2l1.87,5.59H7.38L6.85,9.47H4.92l-.5,1.69ZM5.1,8.86H6.66L6.18,7.32c-.15-.48-.25-.86-.32-1.16a8.27,8.27,0,0,1-.25,1.07Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.55,11.16V5.57h1.72a2.78,2.78,0,0,1,.9.11,1.25,1.25,0,0,1,.64.54,1.89,1.89,0,0,1,.23,1,1.94,1.94,0,0,1-.38,1.23,1.62,1.62,0,0,1-1.33.48H9.15v2.27Zm.6-2.93h1.19A1.18,1.18,0,0,0,11.16,8a1.05,1.05,0,0,0,.26-.77,1.26,1.26,0,0,0-.13-.57A.8.8,0,0,0,11,6.32a1.63,1.63,0,0,0-.65-.09H9.15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack396);
export default __webpack_public_path__ + "static/media/Symbol_pack_396.0f2a1b1f90fa64073223056a3850fd26.svg";
export { ForwardRef as ReactComponent };